<template>
  <div class="filed is-centered">
    <div class="control">
      <RouterLink
        class="button is-text"
        :to="{ name: 'SignIn' }"
      >
        ¿ya tienes una cuenta?
      </RouterLink>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinkSignIn',
};
</script>
